var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"friendlyLink"},[_c('div',{staticClass:"txt"},[_vm._v("友情链接：")]),_c('div',{staticClass:"imgs"},_vm._l((_vm.imgList),function(item,index){return _c('a',{key:index,staticClass:"item",attrs:{"href":item.url,"target":"_blank"}},[_c('img',{attrs:{"src":item.img_url,"alt":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }